app.controller(
    'ItineraryCreationController', ['$scope', '$rootScope', '$state', '$stateParams', '$translate', '$sce', '$window', '$timeout', 'FlaneriesService', 'HelperService', 'ExplorerService', ItineraryCreationController]
);

function ItineraryCreationController($scope, $rootScope, $state, $stateParams, $translate, $sce, $window, $timeout, FlaneriesService, HelperService, ExplorerService) {
    var vm = this;
   
    vm.ItineraryVm = {
        ItineraryStepList: [
            {
                ItineraryStepTitle: '',
                DeparturePlace: {},
                ArrivalPlace: {},
                DurationHour: '',
                DurationMinute: '',
                DescriptionForCreationVmList: [
                    { DescriptionTranslation: {} }
                ]
            }
        ]
    };
    $scope.edit = {};
    $scope.edit = {
        etapes: {}
    };
      

    $scope.toggleAll = function () {
        angular.forEach($scope.itinaries, function (itm) {
            console.log(itm);
            itm.selected = $scope.isAllSelected;
        });
    }

    $scope.optionToggled = function () {
        $scope.isAllSelected = $scope.itinaries.every(function (itm) {
            return itm.selected;
        });
    }

    $scope.slider = {
        min: 1,
        max: 24,
        options: {
            floor: 0,
            ceil: 23,
            translate: function (value) {
                return value + 'h';
            },
            hideLimitLabels: true
        }
    };

    $scope.contentTranslate = null;

    $scope.newClient = angular.copy($scope.client);    

    $scope.keywords = ['Restaurant', 'Charme', 'Grande table'];

    $scope.removeKeyword = function (key) {
        $scope.keywords.splice(key, 1);
    };

    $scope.newDescriptifClient = function () {

        for (var i = 0; i < $scope.client.diffuseurs.length; i++) {
            $scope.client.diffuseurs[i].checked = false;
        }
        for (var i = 0; i < $scope.client.clients.length; i++) {
            $scope.client.clients[i]['checked'] = false;
        }
        for (var i = 0; i < $scope.planning.diffuseurs.length; i++) {
            $scope.planning.diffuseurs[i]['checked'] = false;
        }

    };

    $scope.indice = 0;

    $scope.nextDesc = function () {
        if ($scope.indice < $scope.client.length - 1) {
            $scope.indice++;
        }
    };

    $scope.prevDesc = function () {
        if ($scope.indice > 0) {
            $scope.indice--;
        }
    };
    $scope.newDescriptif = false;

    $scope.addDesc = function () {
        $scope.client.unshift({
            name: '24h dans la ville',
            sousTitre: 'Douze expériences choisies, subjectives et assumées',
            titreDesc: '',
            sousTitreDesc: '',
            resumeDesc: '',
            txtDesc: '',
            clients: [
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked: false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked: false
                },
            ],
            classifications: [
                {
                    name: 'Art moderne',
                    checked: true
                },
                {
                    name: 'Haute époque',
                    checked: true
                },
                {
                    name: 'Art moderne',
                    checked: true
                },
                {
                    name: 'Haute époque',
                    checked: true
                },
                {
                    name: 'Art moderne',
                    checked: false
                },
                {
                    name: 'Haute époque',
                    checked: false
                },


            ],
            qualifications: [
                {
                    name: 'Qualification 01',
                    checked: false
                },
                {
                    name: 'Qualification 02',
                    checked: false
                },
                {
                    name: 'Qualification 03',
                    checked: false
                },
                {
                    name: 'Qualification 04',
                    checked: false
                },
                {
                    name: 'Qualification 05',
                    checked: false
                },
                {
                    name: 'Qualification 06',
                    checked: false
                },
                {
                    name: 'Qualification 07',
                    checked: false
                },
                {
                    name: 'Qualification 08',
                    checked: false
                },
                {
                    name: 'Qualification 09',
                    checked: false
                },
                {
                    name: 'Qualification 10',
                    checked: false
                },
                {
                    name: 'Qualification 11',
                    checked: false
                },
                {
                    name: 'Qualification 12',
                    checked: false
                },


            ],
            status: [
                {
                    name: 'Statut 01',
                    checked: false
                },
                {
                    name: 'Statut 02',
                    checked: false
                },
                {
                    name: 'Statut 03',
                    checked: false
                },
                {
                    name: 'Statut 04',
                    checked: false
                },
                {
                    name: 'Statut 05',
                    checked: false
                },
                {
                    name: 'Statut 06',
                    checked: false
                },
                {
                    name: 'Statut 07',
                    checked: false
                },
                {
                    name: 'Statut 08',
                    checked: false
                },
                {
                    name: 'Statut 09',
                    checked: false
                },
                {
                    name: 'Statut 10',
                    checked: false
                },
                {
                    name: 'Statut 11',
                    checked: false
                },
                {
                    name: 'Statut 12',
                    checked: false
                },


            ],
            auteurs: [
                {
                    name: 'Auteur 01',
                    checked: false
                },
                {
                    name: 'Auteur 02',
                    checked: false
                },
                {
                    name: 'Auteur 03',
                    checked: false
                },
                {
                    name: 'Auteur 04',
                    checked: false
                },
                {
                    name: 'Auteur 05',
                    checked: false
                },
                {
                    name: 'Auteur 06',
                    checked: false
                },
                {
                    name: 'Auteur 07',
                    checked: false
                },
                {
                    name: 'Auteur 08',
                    checked: false
                },
                {
                    name: 'Auteur 09',
                    checked: false
                },
                {
                    name: 'Auteur 10',
                    checked: false
                },
                {
                    name: 'Auteur 11',
                    checked: false
                },
                {
                    name: 'Auteur 12',
                    checked: false
                },


            ],
            traducteurs: [
                {
                    name: 'Traducteur 01',
                    checked: false
                },
                {
                    name: 'Traducteur 02',
                    checked: false
                },
                {
                    name: 'Traducteur 03',
                    checked: false
                },
                {
                    name: 'Traducteur 04',
                    checked: false
                },
                {
                    name: 'Traducteur 05',
                    checked: false
                },
                {
                    name: 'Traducteur 06',
                    checked: false
                },
                {
                    name: 'Traducteur 07',
                    checked: false
                },
                {
                    name: 'Traducteur 08',
                    checked: false
                },
                {
                    name: 'Traducteur 09',
                    checked: false
                },
                {
                    name: 'Traducteur 10',
                    checked: false
                },
                {
                    name: 'Traducteur 11',
                    checked: false
                },
                {
                    name: 'Traducteur 12',
                    checked: false
                },


            ],
            correcteurs: [
                {
                    name: 'Correcteur 01',
                    checked: false
                },
                {
                    name: 'Correcteur 02',
                    checked: false
                },
                {
                    name: 'Correcteur 03',
                    checked: false
                },
                {
                    name: 'Correcteur 04',
                    checked: false
                },
                {
                    name: 'Correcteur 05',
                    checked: false
                },
                {
                    name: 'Correcteur 06',
                    checked: false
                },
                {
                    name: 'Correcteur 07',
                    checked: false
                },
                {
                    name: 'Correcteur 08',
                    checked: false
                },
                {
                    name: 'Correcteur 09',
                    checked: false
                },
                {
                    name: 'Correcteur 10',
                    checked: false
                },
                {
                    name: 'Correcteur 11',
                    checked: false
                },
                {
                    name: 'Correcteur 12',
                    checked: false
                },


            ],
            secretairesDeRedaction: [
                {
                    name: 'Secretaire de rédaction 01',
                    checked: false
                },
                {
                    name: 'Secretaire de rédaction 02',
                    checked: false
                },
                {
                    name: 'Secretaire de rédaction 03',
                    checked: false
                },
                {
                    name: 'Secretaire de rédaction 04',
                    checked: false
                },
                {
                    name: 'Secretaire de rédaction 05',
                    checked: false
                },
                {
                    name: 'Rédactrice 06',
                    checked: false
                },
                {
                    name: 'Rédactrice 07',
                    checked: false
                },
                {
                    name: 'Rédactrice 08',
                    checked: false
                },
                {
                    name: 'Rédactrice 09',
                    checked: false
                },
                {
                    name: 'Rédactrice 10',
                    checked: false
                },
                {
                    name: 'Rédactrice 11',
                    checked: false
                },
                {
                    name: 'Rédactrice 12',
                    checked: false
                },


            ],
            langues: [
                {
                    name: 'Français',
                    checked: false
                },
                {
                    name: 'Anglais',
                    checked: false
                },
                {
                    name: 'Japonais',
                    checked: false
                },
                {
                    name: 'Espagnole',
                    checked: false
                },
                {
                    name: 'Italien',
                    checked: false
                },
                {
                    name: 'Allemand',
                    checked: false
                },
                {
                    name: 'Hollandais',
                    checked: false
                },
                {
                    name: 'Corréen',
                    checked: false
                },
                {
                    name: 'Chinois',
                    checked: false
                },
                {
                    name: 'Russe',
                    checked: false
                },
                {
                    name: 'Suédois',
                    checked: false
                },
                {
                    name: 'Grec',
                    checked: false
                },


            ],
            diffuseurs: [
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: true
                },
                {
                    name: 'LV Print',
                    checked: true
                },
                {
                    name: 'LV App',
                    checked: false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked: false
                },
                {
                    name: 'LV Print',
                    checked: false
                },
                {
                    name: 'LV App',
                    checked: false
                },
            ],
            data: '',
            qualification: ''
        });
        $scope.newDescriptif = true;
    };

    $scope.activeDescriptif = function () {
        $scope.newDescriptif = false;
    };

    $scope.addStep = function () {
        $scope.planning.etapes.unshift({
            nameEtape: null,
            schedule: null,
            heureH: null,
            heureM: null,
            dureeH: null,
            dureeM: null,
            titre: null,
            sousTitre: null,
            description: null,
            openDropdown: true,
            edition: true
        });
    };

    /**
     * Liste menu création
     */
    $scope.links = [
        {
            name: 'app.creationItinerary.name',
            label: 'NouvelItineraire',
            state: null // edit-valid, valid
        },
        //{
        //    name: 'app.creationItinerary.contacts',
        //    label: 'Contacts & Droits'
        //},
        //{
        //    name: 'app.creationItinerary.infos',
        //    label: 'Infos complémentaires'
        //},
        {
            name: 'app.creationItinerary.classification',
            label: 'classification'
        },
        {
            name: 'app.creationItinerary.descriptif',
            label: 'descriptif'
        },
        {
            name: 'app.creationItinerary.steps',
            label: 'etapes'
        }
        // [Lam Hong 25-Feb-2022] LVCG-63: LVCG-65 [BO INTERFACE] [24H CREATION] Remove some UI components
        //{
        //    name: 'app.creationItinerary.events',
        //    label: 'ObjetsAssocies'
        //}
        // END
        //{
        //    name: 'app.creationItinerary.visuel',
        //    label: 'Visuel'
        //},
        //{
        //    name: 'app.creationItinerary.sources',
        //    label: 'Sources & Commentaires'
        //}
    ];

    $scope.classificationBox = false;
    $scope.placeAndEventBox = false;

    $scope.showOptionsBox = function (item) {
        $scope.classificationBox = true;
        $scope.placeAndEventBox = false;
        $scope.itemSelected = item;
    }

    $scope.showPlaceAndEventBox = function (item) {
        $scope.classificationBox = false;
        $scope.placeAndEventBox = true;
        $scope.itemSelected = item;
    }

    vm.LoadLists = function () {
        $scope.examples = [
        {
            name: 'categorieEtoile',
            items: vm.ItineraryVm.ParentQualificationList
        },
        {
            name: 'supportDeDiffusion',
            items: vm.ItineraryVm.ClientList
        },
        {
            name: 'GuideEtoile',
            items: vm.ItineraryVm.AssociatedZones
        }
        ];
        $scope.placeAndEvent = [
        {
            name: 'nomLieu',
            items: vm.ItineraryVm.AssociatedPlaces
        }];
    }

    $scope.examples2 = [
        {
            name: 'Classification',
            items: [
                {
                    name: 'LV add'
                },
                {
                    name: 'LV sde'
                },
                {
                    name: 'LV app'
                },
            ]
        }
    ];

    $scope.prevStateUrl = '#';
    $scope.nextStateUrl = '#';
    $scope.currentState = 0;

    angular.forEach($scope.links, function (value, key) {
        if (value.name == $state.current.name) {
            $scope.currentState = key;
            if (key > 0) {
                $scope.prevStateUrl = $scope.links[key - 1].name != '#' ? $state.href($scope.links[key - 1].name) : '#';
            }
            if (key < $scope.links.length - 1) {
                $scope.nextStateUrl = $scope.links[key + 1].name != '#' ? $state.href($scope.links[key + 1].name) : '#';
            }
        }
    });

    $scope.setCurrentState = function (index) {

        index = (index !== 'undefined') ? index : $scope.currentState;

        $scope.currentState = index;
        $scope.prevStateUrl = $scope.links[index - 1] ? ($scope.links[index - 1].name != '#' ? $state.href($scope.links[index - 1].name) : '#') : '#';
        $scope.nextStateUrl = $scope.links[index + 1] ? ($scope.links[index + 1].name != '#' ? $state.href($scope.links[index + 1].name) : '#') : '#';

        $state.go($scope.links[index].name);

        return false;
    };

    $scope.updateState = function (direction) {
        var index = $scope.currentState;
        switch (direction) {
            case -1:
                if (index > 0) {
                    index = $scope.currentState - 1;
                }
                break;

            case +1:
                if (index < $scope.links.length-1) {
                    index = $scope.currentState + 1;
                }
                break;
        }
        $scope.setCurrentState(index);
    }

    $scope.$on('elastic:resize', function (event, element, oldHeight, newHeight) {
        switch (element.attr("ng-model")) {
            case 'newClient.sousTitreDesc':
            case 'newItem.description[0].sousTitreDesc':
            case 'subtitleTranslate':
                element.parents('.row').find('.block-lecture .sous-titre.desc').css('height', newHeight);
                break;

            case 'newClient.txtDesc':
            case 'newItem.description[0].txtDesc':
            case 'contentTranslate':
                element.parents('.row').find('.block-lecture .text-desc').css('height', newHeight);
                break;
        }
    });    

    $translate.use($rootScope.LangForInterface);

    if ($stateParams.qc) {
        vm.ParamQcId = $stateParams.qc;
        // [Lam Hong 08-Dec-2022] LVCG-117: [BO INTERFACE] [Itinerary CREATION] Remove last step
        if (vm.ParamQcId == 10588) {
            if ($scope.links.length == 4) {
                $scope.links.splice(-1);
            }
        }
    }
    else {
        vm.ParamQcId = 10588;
        // [Lam Hong 08-Dec-2022] LVCG-117: [BO INTERFACE] [Itinerary CREATION] Remove last step
        if ($scope.links.length == 4) {
            $scope.links.splice(-1);
        }
    }

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }

    $scope.useCommonCreationTopBar = true;

    initController();

    function initController() {
        GetItineraryForCreation(vm.ParamQcId, $rootScope.LangForWork);
    }

    function GetItineraryForCreation(qc, lang) {
        FlaneriesService.GetItineraryForCreation(qc, lang)
            .then(function (data) {
                console.log(data);
                vm.ItineraryVm = data.data;
                vm.ItineraryVm.ItineraryStepList[0].DurationHour = '';
                vm.ItineraryVm.ItineraryStepList[0].DurationMinute = '';
                vm.GetAssociatedZonesOnSideBar();
                vm.GetPlaceListOfCurrentZone();
                vm.LoadLists();
                //$scope.ChangeZoneById(vm.ParamZoneId);
                $rootScope.CheckDescriptionLengthLimitForObject(qc);                
            });
    }

    $scope.CreateNewObject = function CreateNewSet(redirect) {
        // [Lam Hong 25-Feb-2022] LVCG-63: LVCG-65 [BO INTERFACE] [24H CREATION] 
        // Get the place ID from the "departure" field(the one the user has input) send it to the both insertions: set ArrivalPlace = DeparturePlace if ArrivalPlace IS NULL
        if (vm.ItineraryVm != null && vm.ItineraryVm.ItineraryStepList != null) {
            if (vm.ItineraryVm.ItineraryStepList.length > 0) {
                if (vm.ItineraryVm.ItineraryStepList[0].ArrivalPlace == null) {
                    vm.ItineraryVm.ItineraryStepList[0].ArrivalPlace = vm.ItineraryVm.ItineraryStepList[0].DeparturePlace;
                }
            }
        }
         // END
        FlaneriesService.CreateNewItinerary(vm.ItineraryVm)
            .then(
               function success(data) {
                   if (redirect == true) {
                       $window.location.href = $rootScope.interfaceSubFolder +'/#!/consultation/flaneries?id=' + data.data + '&qc=' + vm.ParamQcId + '&lang=' + $rootScope.LangForWork + '&index=0&sortKey=ItineraryTitle&reverse=false&z=' + vm.ParamZoneId;
                   }
                   else {
                       $window.location.href = $rootScope.interfaceSubFolder + '/#!/creation/itinerary/name?z=' + vm.ParamZoneId + '&qc=' + vm.ParamQcId;
                       GetItineraryForCreation(vm.ParamQcId, $rootScope.LangForWork);
                   }
               },
               function error(data) { 
               });            
    };

    vm.GetAssociatedZonesOnSideBar = function () {
        HelperService.GetAssociatedZonesOnSideBar(0, $rootScope.EnumLinkType.Itinerary, $rootScope.LangForWork, true, vm.ParamZoneId)
            .then(function (data) {
                vm.ItineraryVm.AssociatedZones = data;
                vm.GetPlaceListOfCurrentZone();
                vm.LoadLists();
            });
    }

    vm.GetPlaceListOfCurrentZone = function () {
        HelperService.GetPlaceListOfCurrentZone(vm.ParamZoneId, $rootScope.LangForWork)
            .then(function (data) {
                vm.ItineraryVm.AssociatedPlaceOnSideBarList = data;
                vm.ItineraryVm.AssociatedPlaces = vm.ItineraryVm.AssociatedPlaceOnSideBarList;
                vm.ItineraryVm.AssociatedPlacesForStep = angular.copy(vm.ItineraryVm.AssociatedPlaceOnSideBarList);
                vm.LoadLists();
            });
    }

    //Updoad file - Start
    $scope.informations = {};
    $scope.informations.files = [];
    $scope.openExplorer = function () {
        $timeout(
            function () {
                angular.element('#newupload1').trigger('click');
            }, 0, true
        );
    };    
    $scope.uploadDragNDrop = function (files) {
        for (var i = 0; i < files.length; i++) {
            var name = files[i].name;

            $scope.informations.files.push(files[i]);
        }
        $scope.$apply();
        $scope.uploadFiles();
    };

    $scope.deleteFile = function (index) {
        $scope.informations.files.splice(index, 1);
    };

    $scope.uploadFiles = function () {
        $scope.files = $scope.informations.files;

        if ($scope.files && $scope.files.length) {
            ExplorerService.UploadFilesForObject($scope.files)
            .then(function (response) {
                $timeout(function () {
                    vm.ItineraryVm.UploadFiles = response.data.Explorer.itemList;
                });
            }, function (response) {
                if (response.status > 0) {
                    $scope.errorMsg = response.status + ': ' + response.data;
                }
            }, function (evt) {
                //$scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                console.log($scope.progress);
            });
        }
    };
    $scope.refreshUploadList = function (files) {
        $scope.informations.files = files;
        $scope.uploadFiles();
    }
    //Updoad file - End
}